'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = require('../utils/underscore');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _reactDom = require('react-dom');

var _Selectors = require('../constants/Selectors');

var _UIDialog = require('./UIDialog');

var _UIDialog2 = _interopRequireDefault(_UIDialog);

var _UIDialogCloseButton = require('./UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIOverlay = require('../overlay/UIOverlay');

var _UIOverlay2 = _interopRequireDefault(_UIOverlay);

var _Dom = require('../utils/Dom');

var _decorators = require('../utils/propTypes/decorators');

var _DialogConstants = require('./DialogConstants');

var _ModalContext = require('../context/ModalContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getContext = function getContext(use, headerCallback) {
  return { use: use, headerCallback: headerCallback };
};

var hasPingedNewRelic = false;

// Report "special" modals that lack a proper header (#6712)
var reportDeprecatedModalMarkup = function reportDeprecatedModalMarkup(el) {
  if (!el) return;
  if (el.querySelector('.private-modal__header + .private-modal__body')) return;

  ['success', 'danger', 'info'].forEach(function (variant) {
    for (var headingLevel = 1; headingLevel <= 6; headingLevel++) {
      if (el.querySelector('.private-modal--' + variant + ' .private-modal__body h' + headingLevel)) {
        if (process.env.NODE_ENV !== 'production') {
          _devLogger2.default.warn({
            message: 'Modals with `use="' + variant + '"` should wrap their heading in a `UIDialogHeader`.',
            key: 'legacy-modal-markup'
          });
        }
        if (window.newrelic && !hasPingedNewRelic) {
          window.newrelic.addPageAction('legacy-modal', {
            variant: variant,
            headingLevel: headingLevel
          });
          hasPingedNewRelic = true;
        }
      }
    }
  });
};

var UIModalDialog = function (_React$Component) {
  _inherits(UIModalDialog, _React$Component);

  function UIModalDialog(props) {
    _classCallCheck(this, UIModalDialog);

    var _this = _possibleConstructorReturn(this, (UIModalDialog.__proto__ || Object.getPrototypeOf(UIModalDialog)).call(this, props));

    _this.handleOpenComplete = function () {
      _this.setState({
        openComplete: true
      });

      _this.startMutationObserver();
      _this.captureFocus();
    };

    _this.handleCloseStart = function () {
      if (!_this._isMounted) return;
      _this.stopMutationObserver();
    };

    _this.startMutationObserver = function () {
      if (_this._observer) return;
      var dialog = (0, _reactDom.findDOMNode)(_this._ref);
      if (!dialog) return;

      // The focus should always be inside of the modal. We may need to recapture
      // it after an update because the focused element may have been unmounted.
      _this._observer = new MutationObserver(_this.captureFocus);
      _this._observer.observe(dialog, {
        attributes: true,
        childList: true,
        subtree: true
      });

      // Disable the mutation observer during blur, as the value of
      // document.activeElement in that phase is misleading.
      addEventListener('blur', _this.stopMutationObserver, {
        capture: true
      });
      addEventListener('focus', _this.startMutationObserver, {
        capture: true
      });
    };

    _this.stopMutationObserver = function () {
      if (_this._observer) {
        _this._observer.disconnect();
        _this._observer = null;
      }

      removeEventListener('blur', _this.stopMutationObserver, {
        capture: true
      });
      removeEventListener('focus', _this.startMutationObserver, {
        capture: true
      });
    };

    _this.captureFocus = function () {
      // If the focus is currently within the page (or null/<body>), focus on this
      // dialog so that tabbing works. We *don't* want to capture focus if the
      // element is in a non-page element, e.g. a popover or other modal.
      var dialog = (0, _reactDom.findDOMNode)(_this._ref);
      if (!dialog) return;

      var activeElement = document.activeElement;
      var dialogContainsActiveElement = dialog.contains(activeElement);
      var shouldCapture = false;
      if (!activeElement || activeElement === document.body) {
        shouldCapture = true;
      } else if (!dialogContainsActiveElement) {
        // A few weird apps have multiple .page elements...
        var pages = document.querySelectorAll('body > .page');
        for (var i = 0; i < pages.length; i++) {
          if (pages[i].contains(activeElement)) {
            shouldCapture = true;
            break;
          }
        }
      }
      // Also, we also want to move focus to the dialog if the focus has somehow
      // wound up on a non-focusable element *within* the dialog.
      if (dialogContainsActiveElement && !(0, _Dom.matches)(activeElement, _Selectors.FOCUSABLE)) {
        shouldCapture = true;
      }
      if (shouldCapture) {
        dialog.focus();
      }
    };

    _this.refCallback = function (ref) {
      _this._ref = ref;
    };

    _this.handleKeyDown = function (evt) {
      var onEsc = _this.props.onEsc;

      var dialog = (0, _reactDom.findDOMNode)(_this._ref);
      if (!dialog) return;

      if (evt.key === 'Tab') {
        // Based on https://www.w3.org/TR/wai-aria-practices/#trap_focus_div
        var activeElement = document.activeElement;
        var allFocusableElements = dialog.querySelectorAll(_Selectors.FOCUSABLE);
        var firstFocusableElement = (0, _underscore.first)(allFocusableElements);
        var lastFocusableElement = (0, _underscore.last)(allFocusableElements);

        if (evt.shiftKey) {
          // Shift+Tab: If focus is on first element, cycle to last element
          if (activeElement === firstFocusableElement || activeElement === dialog) {
            evt.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Unmodified Tab: If focus is on last element, cycle to first element
          if (activeElement === lastFocusableElement || activeElement === dialog) {
            evt.preventDefault();
            firstFocusableElement.focus();
          }
        }
      } else if (evt.key === 'Escape') {
        if (typeof onEsc === 'function') {
          onEsc(evt);
        } else {
          var closeButton = dialog.querySelector('[data-action=close]');
          if (closeButton) closeButton.click();
        }
      }
    };

    _this.headerCallback = function (headerOverflow) {
      if (headerOverflow !== _this.state.headerOverflow) {
        _this.setState({ headerOverflow: headerOverflow });
      }
    };

    _this.state = {
      headerOverflow: 0,
      openComplete: !props._openCompleteRelay
    };

    _this._getContext = (0, _memoizeOne2.default)(getContext);

    if (props._openCompleteRelay) props._openCompleteRelay.subscribe(_this.handleOpenComplete);
    if (props._closeStartRelay) props._closeStartRelay.subscribe(_this.handleCloseStart);
    return _this;
  }

  _createClass(UIModalDialog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      reportDeprecatedModalMarkup((0, _reactDom.findDOMNode)(this._ref));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      reportDeprecatedModalMarkup((0, _reactDom.findDOMNode)(this._ref));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      this.stopMutationObserver();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          centered = _props.centered,
          children = _props.children,
          className = _props.className,
          contextual = _props.contextual,
          dialogClassName = _props.dialogClassName,
          _dialogWidth = _props._dialogWidth,
          __onEsc = _props.onEsc,
          role = _props.role,
          size = _props.size,
          use = _props.use,
          _use = _props._use,
          __closeStartRelay = _props._closeStartRelay,
          __openCompleteRelay = _props._openCompleteRelay,
          rest = _objectWithoutProperties(_props, ['centered', 'children', 'className', 'contextual', 'dialogClassName', '_dialogWidth', 'onEsc', 'role', 'size', 'use', '_use', '_closeStartRelay', '_openCompleteRelay']);

      var openComplete = this.state.openComplete;


      var computedUse = _use || use;

      // If one of the children is <UIDialogCloseButton detached>, render it in
      // the overlay instead of the dialog.
      var closeButton = null;
      var dialogChildren = _react2.default.Children.map(children, function (child) {
        if (child === null) {
          return null;
        } else if (child.type === _UIDialogCloseButton2.default && child.props.detached) {
          closeButton = child;
          return null;
        }
        return child;
      });

      var centerContent = ['fullscreen', 'sidebar', 'lightbox'].indexOf(computedUse) === -1;
      return _react2.default.createElement(
        _ModalContext.ModalContextProvider,
        { value: this._getContext(use, this.headerCallback) },
        _react2.default.createElement(
          _UIOverlay2.default,
          _extends({}, rest, {
            centerContent: centerContent,
            className: (0, _classnames2.default)(className, 'private-modal-dialog--overlay'),
            contextual: contextual,
            'data-component-name': 'UIModalDialog',
            'data-open-complete': openComplete,
            onKeyDown: this.handleKeyDown,
            ref: this.refCallback,
            tabIndex: -1
          }),
          _react2.default.createElement(
            _UIDialog2.default,
            {
              _dialogWidth: _dialogWidth,
              centered: centered,
              className: dialogClassName,
              headerOverflow: this.state.headerOverflow,
              role: role !== undefined ? role : 'dialog',
              size: size,
              use: computedUse
            },
            dialogChildren
          ),
          closeButton
        )
      );
    }
  }]);

  return UIModalDialog;
}(_react2.default.Component);

UIModalDialog.propTypes = {
  centered: _propTypes2.default.bool.isRequired,
  children: _propTypes2.default.node,
  contextual: (0, _decorators.hidden)(_propTypes2.default.bool),
  _dialogWidth: _UIDialog2.default.propTypes._dialogWidth,
  dialogClassName: _propTypes2.default.string,
  onEsc: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
  use: _propTypes2.default.oneOf(Object.keys(_DialogConstants.DIALOG_USE_CLASSES)),
  _use: _propTypes2.default.oneOf(['sidebar']),
  width: _UIOverlay2.default.propTypes.width,
  _openCompleteRelay: _propTypes2.default.object,
  _closeStartRelay: _propTypes2.default.object
};

UIModalDialog.contextTypes = {
  sandboxed: _propTypes2.default.bool
};

UIModalDialog.defaultProps = {
  centered: false,
  contextual: false,
  use: 'default',
  size: 'auto',
  width: 450
};

UIModalDialog.displayName = 'UIModalDialog';

exports.default = UIModalDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dialog/UIModalDialog.js
// module id = 202
// module chunks = 177